import { render, staticRenderFns } from "./ChoirPresentationBox.vue?vue&type=template&id=2f53867c&scoped=true&"
import script from "./ChoirPresentationBox.vue?vue&type=script&lang=ts&"
export * from "./ChoirPresentationBox.vue?vue&type=script&lang=ts&"
import style0 from "./ChoirPresentationBox.vue?vue&type=style&index=0&id=2f53867c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53867c",
  null
  
)

export default component.exports